"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.accordionDummy = exports.blankAccordionBody = exports.blankAccordionHeading = exports.accordion = void 0;
var Text_1 = require("./Text");
var BasicBlocks_1 = require("./BasicBlocks");
var Common_1 = require("ContentTokens/Models/Common");
exports.accordion = {
    createToken: function (heading, body, options) {
        return {
            type: "block",
            subType: "accordion",
            heading: heading,
            body: body,
        };
    },
    createSlateJson: function () {
        return {
            isVoid: false,
            type: Common_1.BlockType.Accordion,
            data: { expanded: false },
            children: [(0, exports.accordionDummy)(), (0, exports.blankAccordionHeading)(), (0, exports.blankAccordionBody)()],
        };
    },
};
var blankAccordionHeading = function () {
    return {
        isVoid: false,
        type: Common_1.BlockType.AccordionHeading,
        children: [BasicBlocks_1.heading2.createSlateJson([Text_1.text.createSlateJson("")])],
    };
};
exports.blankAccordionHeading = blankAccordionHeading;
var blankAccordionBody = function () {
    return {
        isVoid: false,
        type: Common_1.BlockType.AccordionBody,
        children: [BasicBlocks_1.paragraph.createSlateJson([Text_1.text.createSlateJson("")])],
    };
};
exports.blankAccordionBody = blankAccordionBody;
var accordionDummy = function () {
    return {
        isVoid: true,
        type: Common_1.BlockType.AccordionDummy,
        children: [Text_1.text.createSlateJson("")],
    };
};
exports.accordionDummy = accordionDummy;
